<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content ? `${content} | Global Press ` : `SITE_NAME` }}</template>
  </metainfo>
  <div id="sg-app-wrap">
    <router-view />
  </div>
</template>

<script setup>
import { useMeta } from 'vue-meta'
import { useI18n } from 'vue-i18n'

const { locale, t } = useI18n()

useMeta({
  title: 'Style Guide',
  description: 'Promoting dignity and precision in the practice of international journalism',
  htmlAttrs: {
    lang: locale.value
  },
  og: {
    title: 'Global Press Journal',
    description: 'Know your world',
    image: [
      'https://gpjs3bucket.s3.amazonaws.com/wp-content/uploads/2022/01/26120142/GPJ_socialshare.png'
    ]
  }
})
</script>

<style scoped>
.sg-app-wrap {
  font-family: "Montserrat", sans-serif;
}
</style>
